// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"src-containers-Posts-styles___pageContainer","loadMoreWrapper":"src-containers-Posts-styles___loadMoreWrapper"};